/**
 * @file Logo
 * @author zhangyou
 */
import React from 'react'
import styled from 'styled-components'
import Logo from '../Logo'

const LogoWrapper = styled(Logo)`
  color: #17233d !important;
  letter-spacing: 0;
  background: #fff !important;
  box-shadow: none !important;
  .isInIframe & {
    display: none;
  }

  &:after {
    display: none;
  }

  .tnt-themeS1 & {
    color: rgba(255, 255, 255, 0.85) !important;
    background: #323b4a !important;
  }
`

export default (props) => <LogoWrapper {...props} />
